import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue,
  SelectItem
} from '@/components/shadcn/Select';
import { jobLevels } from '@/constants/jobLevel';

type Props = {
  value: number;
  onChange: (arg: number) => void;
  placeholder: string;
  className: string;
};

export default function ExperienceLevels({
  value,
  onChange,
  placeholder,
  className
}: Props) {
  return (
    <Select
      value={value.toString()}
      onValueChange={(years: string) => onChange(Number(years))}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder}>
          {jobLevels[value - 1].name}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {jobLevels.map((level, index) => (
          <SelectItem key={index} value={String(level.level)}>
            <div>
              <div>{level.name}</div>
              <div className="text-[12px] text-[#8a8a8a]">
                {level.description}
              </div>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
